import React from "react";

interface Props {
    title: string;
    icon: string;
    count?: number;
    actions?: React.ReactNode;
}

const CardHeader: React.FC<Props> = ({ title, icon, count, actions }) => {
    return <div className="d-flex justify-content-between align-items-center gap-2 border-bottom pb-3">
            <h5 className="mb-0">
                <i className={`mdi ${icon} text-primary me-2`} />
                {title}
            </h5>
            <div className="d-flex align-items-center gap-2">
                {count !== undefined && <span className="badge bg-primary bg-soft text-primary">{count}</span>}
                {actions}
            </div>
        </div>;
};

export default CardHeader;
